import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../Common/const'
import CarFinderForm from '../Components/CarFinder/CarFinderForm'
import SeoMeta from '../Common/SeoMeta'
import { VehicleContext } from '../Context/VehicleContext'

const CarFinder = () => {
    const { getCMSData } = useContext(VehicleContext);
    const [cmsData, setCMSData] = useState({});
    const getPageData = async () => {
        setCMSData(await getCMSData('carfinder'));
    }
    useEffect(() => {
        getPageData();
    }, []);
    const getCMSValue = (field) => {
        return field in cmsData ? cmsData[field] : "";
    }
    const sectionRef = useRef(null);
    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <>
            <SeoMeta
                title="Find An Exotic Car In Tampa, FL And San Clemente, CA | ECC"
                description="Trying to find a car in Tampa, FL and San Clemente, CA? European Exotic Center can help you find the exact vehicle you're looking for."
                keywords=""
                ogTitle="Find An Exotic Car In Tampa, FL And San Clemente, CA | ECC"
                ogDescription="Trying to find a car in Tampa, FL and San Clemente, CA? European Exotic Center can help you find the exact vehicle you're looking for."
            />
            <section className="common-banner-wrap repair-banner consign-banner">
                <img src={getImages('car-finder-hero.webp')} alt='Car Finder' />
                <div className="container">
                    <div className='common-banner-pos pt-5 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>{getCMSValue('CarFinderMainHeading')}</h1>
                        <div className='md-title font-2em fw-400 text-center mt-3 mb-4 wow reveal fadeInUp avenir-next'>{getCMSValue('CarFinderSubHeading')}</div>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase'
                            onClick={scrollToSection}
                            >CLICK TO BEGIN</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className='specific-car-wrap'>
                <div className="container">
                    <div className='row align-items-center'>
                        <div className='col-md-6 text-center order-md-2 wow reveal fadeInRight'>
                            <img src={getImages('specific-car-image.png')} alt='Specific Car' />
                        </div>
                        <div className='col-md-6 mt-md-0 mt-5 wow reveal fadeInLeft'>
                            <div className='add-border-left'>
                                <div className='md-title font-2-5em fw-400 text-uppercase mb-md-4 mb-3'>{getCMSValue('CarFinderContentTitle')}</div>
                                <div className='common-text'>
                                    <p>{getCMSValue('CarFinderContentText')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='consign-car-form-wrap' ref={sectionRef}>
                <div className='container'>
                    <div className='lg-title font-2-5em fw-400 text-uppercase mb-5 text-center wow reveal fadeInUp'>Tell Us About the Vehicle</div>
                    <CarFinderForm/>
                </div>
            </section>
        </>
    )
}

export default CarFinder